import { EToursSectionStateActionTypes, IToursSectionState, IToursSectionStoreAction } from './types';
import { OrderByDirectionEnum } from '../../../store';

export const reducer = (
    state: IToursSectionState,
    action: React.ReducerAction<React.Reducer<any, IToursSectionStoreAction>>,
) => {
    const { toursTotal, orderBy, orderByDirection, showCategories, showMap, showSortMenu } = action
    switch (action.type) {
        case EToursSectionStateActionTypes.SetToursTotal:
            if (toursTotal !== undefined && toursTotal !== state.toursTotal) state = { ...state, toursTotal }
            break;
        case EToursSectionStateActionTypes.SetOrderBy:
            if (orderBy !== undefined && orderBy !== state.orderBy) state = { ...state, orderBy }
            break;
        case EToursSectionStateActionTypes.SetOrderByDirection:
            if (orderByDirection !== undefined && orderByDirection !== state.orderByDirection) state = { ...state, orderByDirection }
            break;
        case EToursSectionStateActionTypes.ToggleOrderByDirection:
            if (state.orderByDirection === OrderByDirectionEnum.asc) state = { ...state, orderByDirection: OrderByDirectionEnum.desc }
            else state = { ...state, orderByDirection: OrderByDirectionEnum.asc }
            break;
        case EToursSectionStateActionTypes.SetShowCategories:
            if (showCategories !== undefined && showCategories !== state.showCategories) state = { ...state, showCategories }
            break;
        case EToursSectionStateActionTypes.ToggleShowCategories:
            state = { ...state, showCategories: !state.showCategories }
            break;
        case EToursSectionStateActionTypes.SetShowMap:
            if (showMap !== undefined && showMap !== state.showMap) state = { ...state, showMap }
            break;
        case EToursSectionStateActionTypes.ToggleShowMap:
            state = { ...state, showMap: !state.showMap }
            break;
        case EToursSectionStateActionTypes.SetShowSortMenu:
            if (showSortMenu !== undefined && showSortMenu !== state.showSortMenu) state = { ...state, showSortMenu }
            break;
    }

    return state
}

// Arata interesant codul, dar nu imi place, desi eu l-am facut - ar fi mai safe subreducere
// const newStateWhenNotEqual = <S, A, SK extends keyof S, AK extends keyof A>(state: S, skey: SK, action: A, akey: AK) => {
//     const newState = { ...state }
//     const newKeyValue: any = action[akey]
//     if (newKeyValue && newKeyValue !== state[skey]) newState[skey] = newKeyValue
//     return newState
// } 